module.exports = __webpack_public_path__ + "img/18.cf75c791.png";